import { ReactElement } from "react";
import styles from "./HorizontalLine.module.scss";

const HorizontalLine = (): ReactElement => {
  return <div className={styles.horizontalLine}></div>;
};

export default HorizontalLine;
